import { fetchQuery, graphql } from "react-relay";

import RelayEnvironment from "@phoenix/RelayEnvironment";

import type { globalDashboardLoaderQuery } from "./__generated__/globalDashboardLoaderQuery.graphql";

export const globalDashboardLoaderGql = graphql`
  query globalDashboardLoaderQuery {
    projects(first: 100) {
      edges {
        node {
          id
          name
          gradientStartColor
          gradientEndColor
          endTime
        }
      }
    }
  }
`;

export async function globalDashboardLoader() {
  return await fetchQuery<globalDashboardLoaderQuery>(
    RelayEnvironment,
    globalDashboardLoaderGql,
    {}
  ).toPromise();
}

export type GlobalDashboardLoaderData = Awaited<
  ReturnType<typeof globalDashboardLoader>
>;
